// hooks/useAuthToken.js
import Cookies from 'js-cookie';

const TOKEN_KEY = 'authToken';
const ID_KEY = 'id';
const EMAIL_KEY = 'email';

const useAuthToken = () => {
  const setAuthData = (token, id, email) => {
    Cookies.set(TOKEN_KEY, token, {
      expires: 1,
      path: '/',
      sameSite: 'None',
      secure: true,
    });

    Cookies.set(ID_KEY, id, {
      expires: 1,
      path: '/',
      sameSite: 'None',
      secure: true,
    });

    if (email) {
      Cookies.set(EMAIL_KEY, email, {
        expires: 1,
        path: '/',
        sameSite: 'None',
        secure: true,
      });
    }
  };

  const getToken = () => Cookies.get(TOKEN_KEY);
  const getUserId = () => Cookies.get(ID_KEY);
  const getUserEmail = () => Cookies.get(EMAIL_KEY);

  const removeAuthData = () => {
    Cookies.remove(TOKEN_KEY);
    Cookies.remove(ID_KEY);
    Cookies.remove(EMAIL_KEY);
  };

  return {
    setAuthData,
    getToken,
    getUserId,
    getUserEmail,
    removeAuthData,
  };
};

export default useAuthToken;